import { BaseApi } from '@/main/baseApi';
import { NAME as SKLAD_PNEU, DMS_MODULE as SKLAD } from '@/modules/sklad/pneuSklad/constants';

import { DMS_MODULE, NAME } from './constants';

class ZakazkaPneuProvider extends BaseApi {
	getPneuSklad(id: number) {
		return this.fetch(`/${SKLAD}/${SKLAD_PNEU}/${id}`);
	}
}
export const apiProvider = new ZakazkaPneuProvider(DMS_MODULE, NAME);
